import { QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import React, { Suspense } from "react"
import { HelmetProvider } from "react-helmet-async"
import { RouterProvider } from "react-router"

import LoadingScreen from "@sap/components/loading-screen"
import NotistackProvider from "@sap/components/snackbar"

import queryClient from "@/api/queryClient"
import LocalizationProvider from "@/locales/LocalizationProvider"
import "@/locales/i18n"
import router from "@/routes"
import Theme from "@/theme/index"

import { loadPostHog } from "./utils/posthog"
import RollbarProvider from "./utils/rollbar"

loadPostHog()

export default function App() {
  return (
    <React.StrictMode>
      <RollbarProvider>
        <HelmetProvider>
          <Theme>
            <QueryClientProvider client={queryClient}>
              <LocalizationProvider>
                <Suspense fallback={<LoadingScreen isDashboard />}>
                  <NotistackProvider>
                    <RouterProvider router={router} />
                    <ReactQueryDevtools initialIsOpen={false} />
                  </NotistackProvider>
                </Suspense>
              </LocalizationProvider>
            </QueryClientProvider>
          </Theme>
        </HelmetProvider>
      </RollbarProvider>
    </React.StrictMode>
  )
}
